export default __webpack_public_path__ + "img/transparent-pixel.png";